import { Component, OnInit, OnDestroy } from '@angular/core';
import { ADKDetailsViewModel } from '../../../models/adk-details-view.model';
import { ManageService } from '../../../services/manage.service';
import { CommonService } from '../../../services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgProgressService } from '../../../services/ngProgress.service';
import { WGSListTableViewModel, WGSSubscriptionDetail, WGSSubscriptionDetailsItemViewModel } from '../../../models/wgs.model';


@Component({
  selector: 'app-manage-wgs-end-user',
  templateUrl: './manage-wgs-end-user.component.html',
  styleUrls: ['./manage-wgs-end-user.component.css']
})
export class ManageWGSEndUserComponent implements OnInit, OnDestroy {
  private tenantId: string;
  private programType: string;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public displayedColumns = ['desc', 'userCount', 'status', 'price', 'total', 'manageBtn'];
  public WGSTableListItems: WGSListTableViewModel[];
  public details: ADKDetailsViewModel;
  public activeTotal = '0';
  public isSubscriptionResponseLoading = false;
  public isWGSItemLoading = true;
  // isTenantManagementLoading = false;

  constructor(
    private manageService: ManageService,
    public commonService: CommonService,
    public ngProgress: NgProgressService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.ngProgress.start();
    this.activatedRoute.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(param => {
      this.manageService.refetchWGSItemsView$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
        this.refetchWGSItemsView();
      });
      this.refetchWGSItemsView();

      this.activatedRoute.parent.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(value => {
        this.programType = value.get('programType');
      });
    },
      (error: any) => {
        console.error(error);
        this.isWGSItemLoading = false;
      });

    this.manageService.currentCSPTenantDetails.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value) => {
      if (value) {
        this.details.customer = value;
      }
    });

    this.manageService
      .getADKDetails(this.tenantId, this.programType)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: ADKDetailsViewModel) => {
        if (res?.tenantId) {
          this.details = res;
        }
      });

    this.manageService.currentSubscriptionConfirmValue.pipe(takeUntil(this.ngUnsubscribe)).subscribe(value => {
      if (value === 'Update') {
        this.refetchWGSItemsView();
      }
    });
  }

  public getWGSProductList(): void {    
    this.router.navigate(['AddWGSProducts'], { relativeTo: this.activatedRoute });
  }

  public manageSubscription(subscription: WGSSubscriptionDetail): void {
    this.manageService.WGSSubscriptionDetail.next(subscription);
    this.router.navigate(['subscription/' + subscription?.subscriptionContractId], { relativeTo: this.activatedRoute });
  }

  private refetchWGSItemsView(): void {
    this.manageService.getCurrentWGSContractResellerId
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(resellerId => {
        if (resellerId) {
          this.manageService.getWGSItemsView(resellerId).subscribe((model: WGSSubscriptionDetailsItemViewModel) => {
            this.activeTotal = '0';
            this.isWGSItemLoading = false;
            this.WGSTableListItems = model.subscriptions.map(view => ({
                subscriptionListView: view,
                subscriptionDetailView: null
              } as WGSListTableViewModel
            ));
      
            model.subscriptions.forEach((s, index) => {
      
              this.activeTotal = (this.commonService.toNumber(this.activeTotal) + this.commonService.toNumber(s.out_amount)).toString();
              this.GetWGSSubscriptionDetail(s?.out_subscription_id.toUpperCase(), index)
            })
          },
            (error: any) => {
              console.error(error);
            });
        }
      })
  }

  private GetWGSSubscriptionDetail(subscriptionId: string, index: number) {
    this.manageService.GetWGSSubscriptionDetail(this.tenantId.toLocaleLowerCase(), subscriptionId.toUpperCase())
      .pipe(takeUntil(this.ngUnsubscribe)).subscribe((detail: WGSSubscriptionDetail) => {
        if (!this.commonService.isEmpty(detail)) {

          this.WGSTableListItems[index].subscriptionDetailView = detail
        }
      }, (error: any) => {
        this.commonService.implementToast(error, 'Error');
      })
  }

  close() {
    this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/' + this.programType);
    $('#levelOne').animate({ scrollLeft: 0 }, 400);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
